import React from "react";
import { Sheet } from "../ui/sheet";
import { convertEpochToGMT, convertSymbols } from "../../utils/helpers";
import { DATEFORMATS } from "../../globals/globals";

interface GoldenConfigurationRow {
  id: number;
  definitionName?: string;
  description?: string;
  nodeType?: string;
  technology?: string;
  version?: string;
  lastUpdated?: number;
  lastRun?: number;
  passCount?: number;
  failCount?: number;
  skipCount?: number;
}

interface GoldenConfigurationDetailsDrawerProps {
  open: boolean;
  onClose: () => void;
  row: GoldenConfigurationRow | null;
}

const Field: React.FC<{ label: string; value?: React.ReactNode }> = ({ label, value }) => (
  <div className="rounded-md border border-border bg-card p-3">
    <p className="text-xs text-muted-foreground mb-1">{label}</p>
    <div className="flex justify-center">
      <p className="text-sm font-medium text-foreground text-center">{value ?? "-"}</p>
    </div>
  </div>
);

const GoldenConfigurationDetailsDrawer: React.FC<GoldenConfigurationDetailsDrawerProps> = ({ open, onClose, row }) => {
  const title = convertSymbols(row?.description || row?.definitionName || "Golden Configuration");

  return (
    <Sheet
      open={open}
      onClose={onClose}
      title={title}
      subtitle="Golden Configuration details"
      useCardStyle={false}
      width="760px"
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <Field label="Node Type" value={row?.nodeType || "-"} />
          <Field label="Technology" value={row?.technology || "-"} />
          <Field label="Image Constraint" value={convertSymbols(row?.version || "-")} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Field
            label="Last Update"
            value={row?.lastUpdated ? `${convertEpochToGMT(row.lastUpdated, DATEFORMATS.TS)} (GMT)` : "-"}
          />
          <Field
            label="Last Run"
            value={row?.lastRun ? `${convertEpochToGMT(row.lastRun, DATEFORMATS.TS)} (GMT)` : "-"}
          />
        </div>

        <div className="rounded-md border border-border bg-card p-3">
          <p className="text-xs text-muted-foreground mb-2">Results (Last Run)</p>
          <div className="flex items-center justify-center gap-6 text-sm">
            <span className="inline-flex items-center gap-1 text-success">
              <span className="material-icons select-none" aria-hidden="true" style={{ fontSize: 16 }}>check_circle</span>
              <span>Pass: {row?.passCount ?? 0}</span>
            </span>
            <span className="inline-flex items-center gap-1 text-destructive">
              <span className="material-icons select-none" aria-hidden="true" style={{ fontSize: 16 }}>cancel</span>
              <span>Fail: {row?.failCount ?? 0}</span>
            </span>
            <span className="inline-flex items-center gap-1 text-muted-foreground">
              <span className="material-icons select-none" aria-hidden="true" style={{ fontSize: 16 }}>skip_next</span>
              <span>Skipped: {row?.skipCount ?? 0}</span>
            </span>
          </div>
        </div>
      </div>
    </Sheet>
  );
};

export default GoldenConfigurationDetailsDrawer;